<template>
  <div class="admin-categories">
    <header-title title="Apertura de Cajón"></header-title>

    <div class="category-btn">
      <v-btn
        @click="openCashDrawerDialog('addCashDrawer')"
        :style="adminNavigationBackTheme"
        dense
        outlined
      >
        + Nuevo Cajon
      </v-btn>
    </div>

    <v-container fluid class="pl-0 pr-0">
      <v-row justify="center">
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-text-field
            outlined
            dense
            label="Buscar"
            v-model="search"
            class="select-box"
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-select
            dense
            outlined
            class="select-box"
            v-model="activeSelected"
            :items="activeOptions"
            item-text="label"
            item-value="value"
            label="Activo"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" justify="center" md="3" lg="2">
          <v-btn
            dense
            outlined
            @click="resetFilters"
            :style="adminResetFiltersTheme"
          >
            Borrar Filtros
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="cashDrawersFiltered"
          class="elevation-1 payments-table"
          :search="search"
          :footer-props="{
            'items-per-page-options': [50, 100, 150, -1]
          }"
          :items-per-page="50"
          no-data-text="No se han encontrado resultados !"
        >
          <template v-slot:[`item.active`]="{ item }">
            <div style="display:flex;">
              <v-switch
                v-model="item.active"
                @change="markOneCashDrawerAsActive($event, item)"
              ></v-switch>
            </div>
          </template>
          <template v-slot:[`item.editAction`]="{ item }">
            <v-icon small class="mr-2" @click="openCashDrawerDialog(item.id)">
              mdi-pencil
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <CashDrawerDialog ref="cashDrawerDialog"></CashDrawerDialog>
  </div>
</template>

<script>
import {
  cashDrawersCollection,
  updateCashDrawer
} from "@/collections/cashDrawer";
import CashDrawerDialog from "../../../components/admin/printer/CashDrawerDialog";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import { CashDrawerTableHeader } from "@/utils/tableHeaderconstants";

// eslint-disable-next-line no-unused-vars
let fromRoute = undefined;
export default {
  name: "cash-drawers",
  components: {
    CashDrawerDialog,
    HeaderTitle
  },
  data() {
    return {
      cashDrawers: [],
      search: "",
      headers: [...CashDrawerTableHeader],
      activeSelected: "",
      activeOptions: [
        {
          label: "Si",
          value: true
        },
        {
          label: "No",
          value: false
        }
      ]
    };
  },
  firestore() {
    return {
      cashDrawers: cashDrawersCollection
    };
  },
  computed: {
    cashDrawersFiltered() {
      if (this.search !== "" || this.activeSelected !== "") {
        let search = this.cashDrawers;

        return this.activeSelected !== ""
          ? search.filter(
              cashDrawer => this.activeSelected === cashDrawer.active
            )
          : search;
      }

      return this.cashDrawers;
    }
  },
  mounted() {
    setTimeout(() => {}, 2000);
  },
  methods: {
    resetFilters() {
      this.activeSelected = "";
      this.search = "";
    },
    markOneCashDrawerAsActive(value, cashDrawer) {
      updateCashDrawer(cashDrawer.id, { active: value });
    },
    openCashDrawerDialog(itemId) {
      this.$refs.cashDrawerDialog.open(itemId);
    }
  },
  beforeRouteEnter(to, from, next) {
    fromRoute = from;
    next();
  }
};
</script>

<style></style>
